<template>
	<div class="userinfo" v-loading="data_loading" ref="height_top" v-bind:style="{ height: tableHeight + 'px' }" style="overflow: auto;">
		<div style="">
			<el-row>
				<el-col :span="24">
					<el-row>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
							<div class="addr_title">
								<span>
									收件人
								</span>
								<el-input v-model="search.linkman" style="width: 200px" placeholder="请输入收件人" />
								<el-button-group class="button">
									<el-button style="color:#ff8a5c" @click='getaddress'>查询</el-button>
									<el-button style="color:#ff8a5c" @click="add_data">新增收货地址</el-button>
								</el-button-group>
							</div>
						</el-col>
					</el-row>
					<el-row >
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-for="item in data">
							<div class="addr_content">
								<el-row>
									<el-col :span="12">
										<div class="title">
											<span class="name">
												{{item.linkman}}-{{item.province_name}}
											</span>
											<span>
												|
											</span>
											<el-button-group class="button" v-if="item.type==1">
												<el-button color="#ff8a5c" size="small" style="color:#fff">默认收货地址</el-button>
											</el-button-group>
										</div>
									</el-col>
									<el-col :span="12">
										<div class="title_ma" style="text-align:right">
											<span v-if="item.type!=1">
												<el-button size="small" style="color:#9c9e9e" text @click="save_type(item)">设为默认</el-button>
											</span>
											<span>
												|
											</span>
											<span>
												<el-button size="small" style="color:#9c9e9e" text @click="save(item)">编辑</el-button>
											</span>
											<span>
												|
											</span>
											<span>
												<el-button size="small" style="color:#9c9e9e" text @click="del(item.id)">删除</el-button>
											</span>
										</div>
									</el-col>
								</el-row>
								<el-row style="color:#6a6867" class="content">
									<el-col :span="24" class="phone">
										<el-row>
											<el-col :xs="24" :sm="12" :md="6" :lg="4" :xl="4">收件人：{{item.linkman}}</el-col>
											<el-col :xs="24" :sm="12" :md="6" :lg="4" :xl="4">联系方式：{{item.mobile}}</el-col>
											<!-- <el-col :xs="24" :sm="12" :md="6" :lg="3" :xl="3">电话：{{item.tel}}</el-col> -->
											<!-- <el-col :xs="24" :sm="12" :md="6" :lg="3" :xl="3">邮编：{{item.zip_code}}</el-col> -->
											<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">所在地区：{{item.province_name+'-'+item.city_name+'-'+item.district_name}}</el-col>
											<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">地址：{{item.address}}</el-col>
										</el-row>
									</el-col>
									<!-- <el-col :span="24" class="phone">
										<el-row>
											
										</el-row>
									</el-col> -->
								</el-row>
							</div>
							<!--  -->
						</el-col>
						
					</el-row>
				</el-col>
			</el-row>
		</div>
		<el-dialog title="收货地址" v-model="addr_show" width="800px" :close-on-click-modal="false">
			<el-form :model="form" ref="formData" :rules="rules" label-width="auto">
				<el-row>
					<el-col :span="24">
						<el-col :span="24">
							<el-form-item label="收件人：" prop="linkman">
								<el-input v-model="form.linkman" />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="联系方式：" prop="mobile">
								<el-input v-model="form.mobile" />
							</el-form-item>
						</el-col>
						<!-- <el-col :span="24">
							<el-form-item label="电话：" prop="tel">
								<el-input v-model="form.tel" />
							</el-form-item>
						</el-col> -->
						<!-- <el-col :span="24">
							<el-form-item label="邮编：" prop="zip_code">
								<el-input v-model="form.zip_code" />
							</el-form-item>
						</el-col> -->
						<el-col :span="24" class="">
							<el-row>
								<el-col :xs="16" :sm="14" :md="14" :lg="14" :xl="10">
									<el-form-item label="所在地区：" prop="province_id">
										<el-select v-model="form.province_id" placeholder="请选择省份" @change="changeProvices">
											<el-option :label="item.name" v-for="(item,key) in provices" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="4" :sm="5" :md="5" :lg="5" :xl="7">
									<el-form-item label="" prop="city_id">
										<el-select v-model="form.city_id" placeholder="请选择城市" @change="changeCity">
											<el-option :label="item.name" v-for="(item,key) in city" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="4" :sm="5" :md="5" :lg="5" :xl="7">
									<el-form-item label="" prop="district_id">
										<el-select v-model="form.district_id" placeholder="请选择区" @change="changeDistrict">
											<el-option :label="item.name" v-for="(item,key) in district" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="24">
							<el-form-item label="地址：" prop="address">
								<el-input v-model="form.address" placeholder="请输入收货地址">
									<!-- <template #prepend>{{form.province_city}}</template> -->
								</el-input>
							</el-form-item>
						</el-col>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer" center="right">
				<el-button @click="addr_show = false">取 消</el-button>
				<el-button type="primary" @click="saveuser" :loading='loading'>确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
export default {
	components: {},
	data() {

		return {
			search:{
				linkman:'',
			},
			data_loading:false,
			data:[],
			tableHeight: '',
			addr_show: false,
			form: {},
			rules: { //change

				linkman: [{
					required: true,
					message: '请填写收件人',
					trigger: 'blur'
				}],
				mobile: [{
					required: true,
					message: '请填写联系方式',
					trigger: 'blur'
				}],
				tel: [{
					required: true,
					message: '请填写电话',
					trigger: 'blur'
				}],
				zip_code: [{
					required: true,
					message: '请填写邮编',
					trigger: 'blur'
				}],
				address: [{
					required: true,
					message: '请填写地址',
					trigger: 'blur'
				}],
				province_id: [{
					required: true,
					message: '请选择省',
					trigger: 'change'
				}],
				city_id: [{
					required: true,
					message: '请选择城市',
					trigger: 'change'
				}],
				district_id: [{
					required: true,
					message: '请选择区',
					trigger: 'change'
				}],
			},
			district: [],
			provices: [],
			city: [],
			loading: false,

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {
		this.getProvices();
		this.getaddress();
		this.tableHeight_fun();
	},
	watch: {

	},
	methods: {
		add_data(){
			this.form={};
			this.addr_show=true;
		},
		async getProvices() {
			await this.$axios.post('/api/yunsys.Website/getProvices').then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						this.provices = []
					} else {
						this.provices = res.data;
						this.set_province_city();
					}

				})
				.catch(err => {
					this.provices = []
				})
		},
		async getdistrict() {
			await this.$axios.post('/api/yunsys.Website/getcitys', { id: this.form.city_id }).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						this.district = []
					} else {
						this.district = res.data;
						this.set_province_city();
					}

				})
				.catch(err => {
					this.district = []
				})
		},
		async getcitys() {
			await this.$axios.post('/api/yunsys.Website/getcitys', { id: this.form.province_id }).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						this.city = []
					} else {
						this.city = res.data;
						this.set_province_city();
					}

				})
				.catch(err => {
					this.city = []
				})
		},
		changeProvices() {
			this.set_province_city();
			this.form.city_id = ""
			this.form.district_id = ""
			this.district=[]
			this.getcitys();
		},
		changeCity() {
			this.set_province_city();
			this.form.district_id = ""
			this.getdistrict();
		},
		changeDistrict() {
			this.set_province_city();
		},
		set_province_city() {

		},
		del(id) {
			ElMessageBox.confirm(
					'确认删除此收货地址，不可恢复！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.del_ajax(id)
				})
				.catch(() => {

				})

		},
		async del_ajax(id) {
			await this.$axios.post('/api/yunsys.Website/deladdress', { id}).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.getaddress();
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		async save_type(item){
			var data=JSON.parse(JSON.stringify(item))
			data.type=1;
			await this.$axios.post('/api/yunsys.Website/saveaddress', data).then(async (res) => {
							var res = res.data;
							if (res.code !== 0) {
								return ElMessage({
									message: res.msg,
									type: 'error',
									grouping: true // 开启合并功能
								})
							}
							this.getaddress();
							return ElMessage({
								message: res.msg,
								type: 'success',
								grouping: true // 开启合并功能
							})

						})
						.catch(err => {
							return ElMessage({
								message: '系统错误',
								type: 'error',
								grouping: true // 开启合并功能

							})
						})
		},
		save(item) {
			this.form=JSON.parse(JSON.stringify(item))
			this.form.province_id = item.province_id ? item.province_id : '';
			this.form.city_id = item.city_id ? item.city_id : '';
			this.form.district_id = item.district_id ? item.district_id : '';
			this.getcitys();
			this.getdistrict();
			this.addr_show=true;
		},
		async getaddress() {
			this.data_loading=true;
			await this.$axios.post('/api/yunsys.Website/getaddress',this.search).then(async (res) => {
					var res = res.data;
					this.data_loading=false;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					} else {
						this.data=res.data;
					}

				})
				.catch(err => {
					this.data_loading=false;
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		async saveuser() {
			var obj = this;
			this.$refs.formData.validate(async v => {
				if (v) {
					this.loading = true
					await this.$axios.post('/api/yunsys.Website/saveaddress', this.form).then(async (res) => {
							var res = res.data;
							this.loading = false
							if (res.code !== 0) {
								return ElMessage({
									message: res.msg,
									type: 'error',
									grouping: true // 开启合并功能
								})
							}
							this.addr_show=false;
							this.getaddress();
							return ElMessage({
								message: res.msg,
								type: 'success',
								grouping: true // 开启合并功能
							})

						})
						.catch(err => {
							this.loading = false
							return ElMessage({
								message: '系统错误',
								type: 'error',
								grouping: true // 开启合并功能

							})
						})
				} else {
					return ElMessage({
						message: '请填写必填项',
						type: 'error',
						grouping: true // 开启合并功能

					})
				}
			})

		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
			})
		},
	}
}
</script>
<style lang="less" scoped>
:deep(.el-dialog__body) {
	text-align: right;
}
</style>